import { IconButton, IconButtonProps, Tooltip } from '@mui/material';
import { Link } from 'react-router-dom';
import { iconButtonPillStyle } from './iconButtonPillStyle';

type PillIconButtonProps = Omit<IconButtonProps, 'title'> & {
  title?: string;
  to?: string;
};

export const PillIconButton = ({ title, to, ...rest }: PillIconButtonProps) => {
  const button = to ? (
    <IconButton component={Link} to={to} sx={iconButtonPillStyle} {...rest} />
  ) : (
    <IconButton sx={iconButtonPillStyle} {...rest} />
  );
  if (!title) return button;

  return (
    <Tooltip title={title}>{rest.disabled ? <span style={{ display: 'inline-flex' }}>{button}</span> : button}</Tooltip>
  );
};

export default PillIconButton;
